// Provider-agnostic terminal states, as the backend's AIS clients translate them (ZTL:
// REJECTED/EXPIRED/REVOKED -> scaStatus 'failed'; Berlin Group consent statuses otherwise).
// Same set apps/client's consentImpl treats as FAILED.
const FAILED_SCA_STATUSES = new Set(['failed', 'terminated']);
const FAILED_CONSENT_STATUSES = new Set(['rejected', 'revokedByPsu', 'terminated', 'failed']);

export function isTerminalConsentFailure(status: { scaStatus?: string; consentStatus?: string }): boolean {
  return FAILED_SCA_STATUSES.has(status.scaStatus ?? '') || FAILED_CONSENT_STATUSES.has(status.consentStatus ?? '');
}
